import AuditPhotos from './AuditPhotos';

export default AuditPhotos;
